import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { getPartImages } from "../../helpers/conservatoryImage";

import { ExtraWrapper, ImagesContainer, PartImage } from "./style";

const WHITE_FILTER_STYLE = { filter: "brightness(0.15) invert(1)" };

/* <ConservatoryImage /> represents a set of part Images
that together build up a visual representation of the
current conservatory configuration
*/
const ConservatoryImage = ({ smaller, frameType, variant = "full" }) => {
  const { assetBaseUrl } = useSelector((state) => state.init);
  const {
    requestSize,
    requestSizeUpdate,
    requestDesign_Aggregated,
    requestDesignUpdate,
  } = useSelector((state) => state.requests.status);
  const ImagesObj = useSelector((state) => state.Images);
  const Uterum = useSelector((state) => state.Uterum);

  const { Images } = ImagesObj;

  const hasError =
    requestSize === "rejected" ||
    requestSizeUpdate === "rejected" ||
    requestDesign_Aggregated === "rejected" ||
    requestDesignUpdate === "rejected" ||
    !Images ||
    Images.length <= 0;

  if (hasError) {
    return null;
  }

  const partImages = getPartImages(Images, assetBaseUrl, Uterum);

  return (
    // ExtraWrapper necessary for layout reasons
    <ExtraWrapper>
      <ImagesContainer $variant={variant}>
        {/* Placeholder fixes layout issues with position: absolute */}
        <PartImage
          className={"PartImage placeholder"}
          key={partImages[0].id}
          src={partImages[0].src}
          alt="Placeholder"
        />
        {partImages.map((image) => (
          <PartImage
            className={`PartImage ${frameType !== "FIRAXL" ? "animate" : ""}`}
            frameType={frameType}
            smaller={smaller}
            key={image.id}
            src={image.src}
            alt={image.alt}
            style={image.whiteFilter ? WHITE_FILTER_STYLE : undefined}
          />
        ))}
      </ImagesContainer>
    </ExtraWrapper>
  );
};

ConservatoryImage.propTypes = {
  smaller: PropTypes.bool,
  frameType: PropTypes.string,
  variant: PropTypes.oneOf(["full", "thumb", "lightbox"]),
};

export default ConservatoryImage;
